import React from "react";
import "./assets/style/Offer.css";

function Offer() {
  return (
    <section id="offer" className="about-us section-bg">
      <div className="container-fluid" data-aos="fade-up">
        <div className="section-title">
          <h2>Oferta</h2>
        </div>

        <div className="row">
          <div className="col-lg-12 d-flex flex-column justify-content-center align-items-stretch">
            <div className="content">
              <div className="lesson-item">
                <h4>
                  <strong>Slow Yoga</strong>
                  <span className="highlight">(Dobre dla początkujących)</span>
                </h4>
                <p>
                  Łagodna forma jogi, która pozwala rozciągnąć, wzmocnić i zrelaksować ciało w spokojnym tempie. Idealna, jeśli chcesz poprawić elastyczność, odprężyć się i odzyskać wewnętrzną równowagę.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Vinyasa Flow Yoga</strong>
                </h4>
                <p>
                  Dynamiczna, płynna praktyka łącząca ruch z oddechem. Wzmacnia ciało, poprawia koncentrację i elastyczność. Dla kobiet, które lubią energiczny, ale jednocześnie medytacyjny ruch.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Ashtanga Yoga</strong>
                </h4>
                <p>
                  Strukturalna, intensywna praktyka oparta na stałej sekwencji pozycji. Wzmacnia mięśnie, uczy dyscypliny i pracy z oddechem. Doskonała dla osób szukających wyzwania i systematyczności w praktyce.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Joga prenatalna</strong>
                  <span className="highlight">(Dobre dla początkujących)</span>
                </h4>
                <p>
                  Łagodna, świadoma forma jogi odpowiednia nie tylko dla kobiet w ciąży, ale także dla wszystkich, którzy chcą praktykować w bezpieczny, spokojny i regenerujący sposób. Pomaga rozluźnić ciało, uwolnić napięcia, pogłębić oddech i wzmocnić mięśnie głębokie. Idealna, jeśli potrzebujesz uważnego ruchu i odprężenia.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Morning Bliss Yoga</strong>
                </h4>
                <p>
                  Energetyzująca joga na dobry początek dnia. Pomaga rozbudzić ciało, wzmocnić je i nabrać pozytywnej energii. Idealna, jeśli chcesz zacząć poranek z lekkością i klarownym umysłem.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Fit Body</strong>
                </h4>
                <p>
                  Trening ogólnorozwojowy, który łączy ćwiczenia siłowe i cardio. Modeluje sylwetkę, poprawia kondycję i pozwala poczuć moc swojego ciała.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Trening obwodowy</strong>
                </h4>
                <p>
                  Trening obwodowy to intensywna sesja, która łączy elementy siłowe i wytrzymałościowe, aby maksymalnie zaangażować wszystkie partie mięśniowe. Dzięki szybkiemu tempu i różnorodności ćwiczeń, skutecznie spalisz kalorie i poprawisz kondycję. To idealna forma treningu dla kobiet, które chcą efektywnie wykorzystać czas i poczuć moc endorfin. Dobry wybór dla Ciebie, jeśli chcesz spalić kalorie, poprawić ogólną kondycję oraz zbudować silne i smukłe ciało.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Silne Ciało</strong>
                </h4>
                <p>
                  Trening skupiony na wzmacnianiu i stabilizacji całego ciała. Buduje siłę, wytrzymałość i pewność siebie. Odpowiedni dla każdego poziomu zaawansowania.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Pilates</strong>
                </h4>
                <p>
                  Ćwiczenia wzmacniające mięśnie głębokie, poprawiające postawę i stabilność ciała. Pomaga redukować napięcia i wprowadza harmonię między ciałem a oddechem.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Pilates od zera</strong>
                  <span className="highlight">(Dobre dla początkujących)</span>
                </h4>
                <p>
                  Zajęcia wprowadzające do pilatesu. Nauczysz się podstaw techniki, oddechu i świadomości ciała — idealne, by rozpocząć swoją przygodę z pilatesem.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Zdrowy kręgosłup</strong>
                  <span className="highlight">(Dobre dla początkujących)</span>
                </h4>
                <p>
                  Zajęcia łączące elementy mobilizacji, wzmacniania i rozciągania. Poprawiają postawę, uczą prawidłowych wzorców ruchu i wzmacniają mięśnie głębokie. Idealne, jeśli chcesz zadbać o zdrowie pleców, zwiększyć zakres ruchu i uwolnić ciało od napięć.
                </p>
              </div>

              <div className="lesson-item">
                <h4>
                  <strong>Stretching</strong>
                </h4>
                <p>
                  Zajęcia rozciągające, które zwiększają elastyczność i zakres ruchu. Pomagają rozluźnić mięśnie, zredukować napięcia i poprawić postawę.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Offer;
